import React from 'react';
import { Link } from 'react-router-dom';
import useEsMovil from '../hooks/useEsMovil';
import FranjaMarca from './FranjaMarca';

const enlaceStyle = {
  color: 'var(--tu-blue)',
  fontSize: '13px',
  fontWeight: 600,
  textDecoration: 'none',
  border: '1.5px solid var(--tu-border)',
  borderRadius: 'var(--tu-radius-sm)',
  padding: '6px 12px',
  whiteSpace: 'nowrap',
};

// Header compartido: logo real (antes cada pantalla escribia "TU ARTISTICA"
// en texto) + accesos comunes. `volverA` muestra el link de vuelta (la
// mayoria de las pantallas internas); `children` son los botones/enlaces
// propios de esa pantalla (ej. el saludo y "Cerrar sesion" del Dashboard).
function Header({ titulo, volverA = '/dashboard', volverTexto = '← Volver al panel', children }) {
  const esMovil = useEsMovil();
  return (
    <div
      style={{
        background: 'var(--tu-surface)',
        borderBottom: '1px solid var(--tu-border)',
        padding: esMovil ? '10px 16px' : '12px 32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: 'var(--tu-shadow)',
        flexWrap: 'wrap',
        gap: '10px',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: esMovil ? '10px' : '16px', flexWrap: 'wrap' }}>
        <Link to="/dashboard" style={{ display: 'flex', alignItems: 'center' }}>
          {/* En el celular, el elefante solo (Mica, 2026-10-26): el logo
              largo no entra al lado del título. */}
          <img
            src={esMovil ? '/icono-192.png' : '/logo-tu-artistica.png'}
            alt="Tu Artística"
            style={{ height: esMovil ? '34px' : '32px', display: 'block' }}
          />
        </Link>
        {titulo && (
          <>
            <span style={{ color: 'var(--tu-border)', fontSize: esMovil ? '18px' : '22px', fontWeight: 300 }}>|</span>
            <h1 style={{ color: 'var(--tu-text)', margin: 0, fontSize: esMovil ? '15px' : '18px', fontWeight: 600 }}>
              {titulo}
            </h1>
          </>
        )}
        {volverA && (
          <Link to={volverA} style={enlaceStyle}>
            {volverTexto}
          </Link>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: esMovil ? '8px' : '14px',
          flexWrap: 'wrap',
          // Deja lugar a las campanitas de notificaciones (CampanaNotificaciones.js),
          // que son position:fixed arriba a la derecha y si no, tapan lo que
          // haya aca (ej. el boton de "Cerrar sesion").
          paddingRight: esMovil ? '96px' : '130px',
        }}
      >
        {children}
        {/* Actualizar sin perder la sesión (pedido de Mica, 2026-10-08): la
            sesión y los desbloqueos con contraseña se mantienen al recargar. */}
        <button
          onClick={() => window.location.reload()}
          title="Traer los datos más nuevos (no cierra la sesión)"
          style={{ ...enlaceStyle, background: 'white', cursor: 'pointer' }}
        >
          🔄 Actualizar
        </button>
      </div>
      {/* Franja con los colores del local, plenos (Mica, 2026-10-09). */}
      <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
        <FranjaMarca alto={4} />
      </div>
    </div>
  );
}

export { enlaceStyle };
export default Header;
